import { VehiclePlateType } from '@/common/types/Files.type';
import { Box, Flex } from 'styled-system/jsx';
import VehiclePlateIcon from '@/common/assets/icons/vehiclePlateIcon.svg?react';
import { css } from 'styled-system/css';
import Typography from '@/common/components/base/typography/Typography';

const VehiclePlateShow = ({ plateData }: { plateData: VehiclePlateType }) => {
  return (
    <Flex
      className={css({
        flexDirection: 'row-reverse',
        alignItems: 'center',
      })}
    >
      <Box
        className={css({
          bg: '#0042AD',
          borderLeftRadius: '4px',
          borderRight: 'none',
          width: '15px',
        })}
      >
        <VehiclePlateIcon
          className={css({
            height: '24px',
            position: 'relative',
            left: '10px',
          })}
        />
      </Box>
      <Box
        className={css({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row-reverse',
          px: '5px',
          gap: '3px',
          border: '1px solid',
          height: '24px',
        })}
      >
        <Typography fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_left}
        </Typography>
        <Typography fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_letter?.letter}
        </Typography>
        <Typography fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_right}
        </Typography>
      </Box>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          height: '24px',
          alignItems: 'center',
          position: 'relative',
          px: '3px',
          border: '1px solid',
          borderLeft: 'none',
          borderRightRadius: '4px',
        }}
      >
        <Typography
          position={'relative'}
          top={'-6px'}
          fontSize={'6px'}
          textStyle={'b3'}
        >
          ایران
        </Typography>
        <Typography
          position={'relative'}
          top={'-20px'}
          fontSize={'11px'}
          textStyle={'b3'}
        >
          {plateData.vehicle_plate_iran}
        </Typography>
      </Box>
    </Flex>
  );
};

export default VehiclePlateShow;
